// Priority Call
export default class Kmklabs {

  constructor({ $element: $element }) {
    this.$element = $element;
    window.kmklabs = {
      video: {
        id: this.$element.attr("data-video-id"),
        premium: this.$element.attr("data-video-premium")
      },
      category: {
        id: this.$element.attr("data-category-id"),
        name: this.$element.attr("data-category-name")
      },
      collection: {
        id: this.$element.attr("data-collection-id"),
        name: this.$element.attr("data-collection-name")
      },
      source: this.$element.attr("data-source"),
      userType: this.$element.attr("data-user-type"),
      gtm: {
        category_id: this.getAttr("data-category-id"),
        category_name: this.getAttr("data-category-name"),
        collection_id: this.getAttr("data-collection-id"),
        collection_name: this.getAttr("data-collection-name"),
        source: this.getAttr("data-source"),
        userType: this.getAttr("data-user-type"),
        visitor_id: this.getCookie("ahoy_visitor"),
        video_id: this.getAttr("data-video-id"),
        user_id: this.getAttr("data-user-id"),
        user_name: this.getAttr("data-user-name"),
        login_status: this.getAttr("data-user-id") ? true : false,
        platform: this.getAttr("data-platform"),
        tag: this.getAttr("data-tag"),
        owner_id: this.getAttr("data-owner-id"),
        owner_name: this.getAttr("data-owner-name"),
        live_id: this.getAttr("data-live-id"),
        live_title: this.getAttr("data-live-title"),
        live_type: this.getAttr("data-live-type"),
        user_gender: this.getAttr("data-user-gender"),
      },
      watermark_timestamp: this.getAttr("data-watermark-timestamp"),
      live: {
        streamRight: this.getAttr("data-live-stream-right"),
        chatEnabled: this.getAttr("data-live-chat-enabled")
      }
    };
  }

  getAttr(attr) {
    var value = this.$element.attr(attr);
    if(value) {
      return value;
    } else {
      return "";
    }
  }

  getCookie(name) {
    var i, c;
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (i = 0; i < ca.length; i++) {
      c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return window.unescape(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  }
}
